module.exports = __webpack_public_path__ + "img/bjt.22be41d9.png";